var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg122Mute1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.894,322.205c1.864,0.542,3.744,0.8,5.592,0.8c8.668,0,16.654-5.68,19.196-14.422 C439.538,291.878,442,274.523,442,257c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,13.744-1.927,27.342-5.729,40.417 C393.188,308.023,399.287,319.122,409.894,322.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.142,477.858l-472-472c-7.81-7.811-20.473-7.81-28.284,0c-7.811,7.81-7.811,20.473,0,28.284L151,179.284V257 c0,57.897,47.103,105,105,105c21.444,0,41.996-6.431,59.354-18.362l29.02,29.02C319.306,391.693,288.904,402,257,402 c-0.167,0-0.334,0.002-0.5,0.006c-0.166-0.004-0.333-0.006-0.5-0.006c-79.953,0-145-65.047-145-145c0-11.046-8.954-20-20-20 s-20,8.954-20,20c0,95.253,72.361,173.923,165,183.926V472h-59c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h160 c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20h-61v-30.963c35.564-3.623,68.999-17.39,96.867-39.886l104.991,104.991 C481.763,510.047,486.881,512,492,512c5.119,0,10.237-1.953,14.142-5.858C513.953,498.332,513.953,485.668,506.142,477.858z  M256,322c-35.841,0-65-29.159-65-65v-37.716l95.265,95.265C277.032,319.416,266.696,322,256,322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.81,82.764c9.812,5.074,21.879,1.236,26.954-8.575C208.673,53.101,230.988,40,256,40c35.841,0,65,29.159,65,65v123 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V105C361,47.103,313.897,0,256,0c-40.027,0-75.956,21.385-93.764,55.811 C157.161,65.622,161,77.689,170.81,82.764z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg122Mute1);
export default __webpack_public_path__ + "static/media/122-mute-1.cab775881e0c646b96320957cc4a5382.svg";
export { ForwardRef as ReactComponent };